import { queries } from '@/lib/api/client/queries/user';
import { useQuery } from '@tanstack/react-query';

const useIsImpersonatingQuery = () => useQuery(queries.isImpersonating);

export default useIsImpersonatingQuery;
